/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calculating_SpeakersInputs */



/**
* | output |
* | --- |
* | "Calculating speakers of events... please wait..." |
*
* @param {Calculating_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const calculating_speakers = /** @type {((inputs?: Calculating_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calculating_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Calcul des intervenants... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anzahl der Redner für die Veranstaltung wird berechnet... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Calcolo dei parlanti degli eventi... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расчет количества выступающих на мероприятиях... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calculando hablantes de eventos... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在计算活动发言人数……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのスピーカーを計算しています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम में शामिल होने वाले वक्ताओं की गणना की जा रही है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Calculando o número de participantes no evento... aguarde...")
	return /** @type {LocalizedString} */ ("Calculating speakers of events... please wait...")
});